import React, { Component } from 'react';
import rq from "./rq.js";
import ReactDOM from "react-dom";
class AutoComplete extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: []
        };
        this.selectedIndex = -1;
        this.showOverlay = false;
        this.spinner = false;
        this.showClear = false;


        this.handleChange = this.handleChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.hideOverlay = this.hideOverlay.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.clearData = this.clearData.bind(this);
    }

    componentWillMount() {
        this.internalValidate(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.reset) {
            this.selectedIndex = -1;
            this.refs.search.value = "";
            this.selectedIndex = -1;
            this.showOverlay = false;
            this.spinner = false;
            this.setState({ data: [] });
        }
    }

    handleChange(e) {
        this.selectedIndex = -1;
        this.showClear = false;
        //this.onSelect(null);
        // temporarly commenting this 

        var searchText = this.refs.search.value;
        //const $that = this;

        // HERE WE CAN SET THE MINIMUM NUMBER OF CHARACTER THAT IS REQUIRED TO MAKE fetch CALL

        if (searchText.length > 0) {
            var dataSrcType = typeof this.props.dataSrc;
            if (dataSrcType === "string") {


                this.spinner = true;
                this.forceUpdate();

                rq.getJsonData(this.props.dataSrc + "?q=" + searchText.toLowerCase()).then((data) => {
                    // this.state.data = data;
                    this.selected = -1;
                    //need to change the selected index to -1
                    this.showOverlay = this.state.data.length > 0 ? true : false;
                    this.spinner = false;
                    this.setState({ data: data });
                }).catch((err) => {
                    throw err;
                });
            } else {
                var filterData = this.props.dataSrc.filter((e, i) => {
                    if (e[this.props.dataTobind].toLowerCase().indexOf(searchText.toLowerCase()) >= 0 && i <= 5)
                        return true;
                    else
                        return false;

                });

                //this.state.data = filterData;
                this.selected = -1;
                //need to change the selected index to -1
                this.showOverlay = filterData.length > 0 ? true : false;
                this.spinner = false;
                this.setState({ data: filterData });
            }


        } else {
            // this.state.data = [];
            this.setState({ data: [] });

        }
        if (!this.refs.search.value) {
            this.onSelect();
            this.showClear = false;
            this.forceUpdate();
        }
    }

    handleKeyDown(e) {
        if (e.keyCode === 40 && this.state.data.length > 0) {
            e.preventDefault();
            this.selectedIndex = this.selectedIndex < this.state.data.length - 1 ? ++this.selectedIndex : 0;
            this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];

            this.forceUpdate();
        }

        if (e.keyCode === 38 && this.state.data.length > 0) {
            e.preventDefault();
            this.selectedIndex = this.selectedIndex > 0 ? --this.selectedIndex : this.state.data.length - 1;
            this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];
            this.forceUpdate();
        }

        if (e.keyCode === 13) {
            if (this.selectedIndex >= 0) {
                this.onSelect(this.state.data[this.selectedIndex]);
                //this.state.data = [];
                this.selectedIndex = -1;
                this.showOverlay = false;
                this.setState({ data: [] });
            }
        }
    }

    decorate(text, searchText) {
        const arr = text.split(searchText);
        return { __html: arr.join('<i class="highlight">' + searchText + '</i>') };
    }
    hideOverlay() {
        this.showOverlay = false;
        //this.state.data = [];
        this.selectedIndex = -1;
        this.setState({ data: [] });
    }
    onSelect(selectedData) {

        //console.log("onSelect fired");
        this.showClear = true;
        this.props.onSelect(selectedData);
        this.hideOverlay();

    }
    handleMouseUp(i) {
        //this.refs.search.value = this.state.data[i][this.props.dataTobind];
        this.selectedIndex = i;
        //this.setState(this.state);
        this.forceUpdate();
    }
    handleBlur(event) {
        // console.log(event);
        //console.log(this.selectedIndex);

        if (this.selectedIndex !== -1) {
            this.refs.search.value = this.state.data[this.selectedIndex][this.props.dataTobind];
            // this.props.onSelect(this.state.data[this.selectedIndex]);
            this.onSelect(this.state.data[this.selectedIndex]);
            this.refs.search.focus();


        } else {
            //this.state.data = [];
            if (this.props.onBlur)
                this.props.onBlur();
            this.setState({ data: [] });

        }

        event.stopPropagation();

    }
    clear() {
        this.onSelect();
        this.refs.search.value = "";
        this.refs.search.focus();
        this.showClear = false;
        this.forceUpdate();
    }




    render() {
        return (
            <div className={this.props.class ? this.props.class + " autoHolder" : "autoHolder"} >

                {this.spinner ? <i className="fa fa-cog fa-spin loader  fa-3x" aria-hidden="true" style={this.props.spinnerStyle || {}}></i> : false}
                {this.showClear ?
                    <i className="fa fa-times-circle" onClick={this.clear.bind(this)} style={Object.assign({ position: "absolute", cursor: "pointer", right: "15px", top: "5px", color: "#b7b7b7", fontSize: "1.5em" }, this.props.clearStyle || {})} aria-hidden="true"></i>
                    : null}
                <input
                    type="text"
                    tabIndex={this.props.tabIndex}
                    placeholder={this.props.placeholder}
                    onChange={this.handleChange}
                    className="formControl inputBox"
                    ref="search"
                    onKeyDown={this.handleKeyDown}
                    width={this.props.width}
                    style={this.props.inputStyle ? this.props.inputStyle : {}}
                    onBlur={this.handleBlur}
                />


                <ul style={this.props.listStyle ? this.props.listStyle : {}}>
                    {this.state.data.map((data, i) => {
                        return (
                            <li style={this.props.liStyle ? this.props.liStyle : {}}
                                className={this.selectedIndex === i ? "selected" : ""}
                                key={data[this.props.keyToBind]}
                                dangerouslySetInnerHTML={this.decorate(data[this.props.dataTobind], this.refs.search.value)}
                                onMouseEnter={this.handleMouseUp.bind(this, i)}
                                onClick={this.handleBlur}
                            >
                            </li>
                        );
                    })}
                </ul>
                {this.showOverlay ? <div className="tOverlay" onClick={this.hideOverlay}></div> : null}
            </div>
        );
    }
    clearData() {
        this.setState({ data: [] });
    }
    componentDidMount() {
        //document.addEventListener('click', this.clearData);
        window.addEventListener('click', this.clearData);
        // ReactDOM.findDOMNode("document").addEventListener("click", () => {
        //     console.log("hiiii");
        // });
        // this is to check if a rex prop is supplied so that it could be foused;
        if (typeof this.props.rex === "function") {
            this.props.rex(this.refs.search);
        }
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.clearData);
    }

    internalValidate(props) {
        if (!props.placeholder) {
            throw new Error("plz provide a placeholder attribute to AutoComplete component");
        }
        if (!props.dataSrc) {
            throw new Error("plz provide a dataSrc attribute to AutoComplete component where ajax call will be made");
        }
        if (!props.dataSrc) {
            throw new Error("plz provide a tabIndex attribute");
        }
    }
}

export default AutoComplete;


// WEBPACK FOOTER //
// ./src/jsx/components/utility/auto-complete.jsx